import Vue from "vue";

import Button from "./Button";
import ProjectStatusBadge from "./ProjectStatusBadge";
import ArrowButton from "./ArrowButton";
import LoadingDialog from "./LoadingDialog";
import Modal from "./Modal";
import LoadingOverlay from "./LoadingOverlay";
import LoadingLogo from "./LoadingLogo";
import SignableWrap from "./SignableWrap";
import EthGasOption from "./EthGasOption";
import TxSteps from "./TxSteps";
import FullScreenModal from "./FullScreenModal";
import FaqSection from "./FaqSection";
import IsMobile from "./IsMobile";

Vue.component("c-btn", Button);
Vue.component("c-project-status-badge", ProjectStatusBadge);
Vue.component("c-arrow-btn", ArrowButton);
Vue.component("c-loading-dialog", LoadingDialog);
Vue.component("c-modal", Modal);
Vue.component("c-loading", LoadingOverlay);
Vue.component("c-loading-logo", LoadingLogo);
Vue.component("c-signable-wrap", SignableWrap);
Vue.component("c-eth-gas-option", EthGasOption);
Vue.component("c-tx-steps", TxSteps);
Vue.component("c-fullscreen-modal", FullScreenModal);
Vue.component("c-faq-section", FaqSection);
Vue.component("c-is-mobile", IsMobile);
